import type { AutomationVersion } from '@/types/automations.ts';

type ConsumerSchemaVersion = Pick<AutomationVersion, 'schemas' | 'available_consumer_schemas'>;

export const getConsumerSchemaOptions = (version: ConsumerSchemaVersion | null | undefined) => {
  const automationSchemas = version?.schemas ?? [];
  const automationSchemaKeys = new Set(
    automationSchemas.map((schema) => `${schema.schema_id}:${schema.version}`),
  );
  return [
    ...automationSchemas.map((schema) => ({
      value: JSON.stringify({ schema_id: schema.schema_id, version: schema.version }),
      label: `${schema.schema_id} v${schema.version} · automation`,
    })),
    ...(version?.available_consumer_schemas ?? [])
      .filter((schema) => !automationSchemaKeys.has(`${schema.schema_id}:${schema.version}`))
      .map((schema) => ({
        value: JSON.stringify({ schema_id: schema.schema_id, version: schema.version }),
        label: `${schema.schema_id} v${schema.version} · platform`,
      })),
  ];
};
